export default __webpack_public_path__ + "static/media/layer4.580367bd.svg";